export default {
  name: 'marking--outHImport',
  apiService: 'shoes',
  apiPath: '/admin/out_h/func/upload',
  urlParamName: 'marking--outHImport',
};
